import { Box, CircularProgress } from '@mui/material';
import ClusterDbSocketProvider from 'components/hooks/ClusterDbSocketProvider';
import { AppLayout, AuthLayout } from 'components/layout';
import { PAGE_LIST } from 'constant/pages';
import { Dashboard, Setting } from 'pages';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

function App() {
  const router = createBrowserRouter([
    {
      element: <AuthLayout />,
      children: [
        {
          path: PAGE_LIST.SETTING.pathname(),
          element: <Setting />,
        },
      ],
    },
    {
      path: '/',
      element: <AppLayout />,
      errorElement: <Navigate to={PAGE_LIST.SETTING.pathname()} />,
      children: [
        {
          index: true,
          element: <Dashboard />,
        },
      ],
    },
  ]);

  return (
    <ClusterDbSocketProvider>
      <RouterProvider
        router={router}
        fallbackElement={
          <Box
            sx={{
              width: '100%',
              height: '100vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress sx={{ color: '#1A96F0' }} />
          </Box>
        }
      />
    </ClusterDbSocketProvider>
  );
}

export default App;
